class EfConsultaTributaria {
    constructor($scope, $filter, modal) {
        this.apply = fun => $scope.$apply(fun)
        this.$filter = $filter
        this.modal = modal
    }

    maisDetalhesPisCofins(pisCofins, resultado) {
        this.modal.open({
            component: 'detalhesTributacaoPisCofins',
            size: 'lg',
            keyboard: 'static',
            resolve: {
                pisCofins: () => pisCofins,
                resultado: () => resultado,
                empresa: () => this.filialId
            }
        })
    }

    filterNcms() {
        return ncm => this.ncm?.startsWith(ncm) || ncm.startsWith(this.ncm)
    }

    isNcmVencida(ncm) {
        if (ncm.vigencia) {
            const today = new Date();
            const vigencia = new Date(ncm.vigencia.split('-'));

            return vigencia < new Date(today.getFullYear(), today.getMonth(), today.getDate());
        }

        return false
    }
}

angular.module("eficienciaFiscalModule")
    .component("efConsultaTributaria", {
        controller: ['$scope', '$filter', '$uibModal', EfConsultaTributaria],
        bindings: {
            filialId: '<',
            ncm: '<',
            consulta: '<',
            promise: '<',
            error: '<',
            form: '<'
        },
        template: `
        <loading promise="$ctrl.empresasPromise">
            <style>
                .empty {
                    color: #bbb;
                    font-size: 0.8em;
                    text-transform: uppercase;
                    letter-spacing: 0.2em;
                }

                .ncm-vencida {
                    color: #999;
                    background: #f0f0f0;                    
                }
            </style>
            <div class="row">
                <loading promise="$ctrl.promise">
                    <ef-collapse
                        class="col-xs-12"
                        ng-if="$ctrl.consulta.ncms.length"
                        cache-as="consulta-tributacao-cest-descricao-ncm">

                        <ef-collapse-header>
                            <h2>Descrição da NCM na TIPI</h2>
                        </ef-collapse-header>

                        <ef-collapse-content>
                            <div class="well well-xs no-padding">
                                <table class="table table-hover no-margin">
                                    <thead>
                                        <tr>
                                            <th width="1">Classificação</th>
                                            <th>Descrição</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr ng-repeat="ncm in $ctrl.consulta.ncms" ng-class="{'ncm-vencida': $ctrl.isNcmVencida(ncm)}">
                                            <td>{{ncm.classificacao | ncm}}</td>
                                            <td>
                                                <span>{{ncm.descricao}}</span>
                                                <div ng-if="$ctrl.isNcmVencida(ncm)" class='help-block txt-color-red font-xs no-margin'>
                                                    <i class="fa fa-exclamation-circle"></i> 
                                                    NCM descontinuada em <b>{{ncm.vigencia | date}}</b>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </ef-collapse-content>
                    </ef-collapse>

                    <ef-collapse
                        class="col-xs-12"
                        ng-if="$ctrl.consulta.farmaceutico"
                        cache-as="consulta-tributacao-cest-dados-medicamento">

                        <ef-collapse-header>
                            <h2>Dados do medicamento</h2>
                        </ef-collapse-header>

                        <ef-collapse-content>
                            <div class="well well-xs no-padding">
                                <table class="table table-hover no-margin">
                                    <thead>
                                        <tr>
                                            <th colspan="2">
                                                Informações do medicamento na ABCFARMA
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <th>Laboratório</th>
                                            <td>{{$ctrl.consulta.farmaceutico.laboratorio}}</td>
                                        </tr>
                                        <tr>
                                            <th>Descrição</th>
                                            <td>{{$ctrl.consulta.farmaceutico.descricao}}</td>
                                        </tr>
                                        <tr>
                                            <th>Princípio ativo</th>
                                            <td>
                                                <span class="empty" ng-hide="$ctrl.consulta.farmaceutico.principioAtivo">VAZIO</span>
                                                <span ng-show="$ctrl.consulta.farmaceutico.principioAtivo">{{$ctrl.consulta.farmaceutico.principioAtivo}}</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Preço máximo de venda</th>
                                            <td>
                                                <span class="empty" ng-hide="$ctrl.consulta.farmaceutico.precoMaximoVenda">VAZIO</span>
                                                <span ng-show="$ctrl.consulta.farmaceutico.precoMaximoVenda">{{$ctrl.consulta.farmaceutico.precoMaximoVenda | currency:'R$ '}}</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Lista</th>
                                            <td>{{$ctrl.consulta.farmaceutico.tipoLista.toUpperCase()}}</td>
                                        </tr>
                                        <tr>
                                            <th>Tipo de medicamento</th>
                                            <td>{{$ctrl.consulta.farmaceutico.tipoMedicamento.toUpperCase()}}</td>
                                        </tr>
                                        <tr>
                                            <th>Apresentação</th>
                                            <td>{{$ctrl.consulta.farmaceutico.apresentacao.toUpperCase()}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </ef-collapse-content>
                    </ef-collapse>

                    <ef-collapse
                        class="col-xs-12"
                        ng-if="$ctrl.consulta.cest.length"
                        cache-as="consulta-tributacao-cest-cest-relacionadas">

                        <ef-collapse-header>
                            <h2>CEST relacionadas com a NCM</h2>
                        </ef-collapse-header>

                        <ef-collapse-content>
                            <div class="well well-xs no-padding">
                                <table class="table table-hover no-margin">
                                    <thead>
                                        <tr>
                                            <th>CEST</th>
                                            <th>NCM</th>
                                            <th>Descrição</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr ng-repeat="resultado in $ctrl.consulta.cest">
                                            <td>{{resultado.cest | cest}}</td>
                                            <td>
                                                <div ng-repeat="ncm in resultado.ncms.uniq() | filter:$ctrl.filterNcms()">
                                                    {{ ncm | ncm }}
                                                </div>
                                            </td>
                                            <td>
                                                <b>{{resultado.segmento.identificador}} - {{resultado.segmento.descricao}}</b>
                                                <br>
                                                {{resultado.descricao}}
                                                <br>
                                                <a
                                                    ng-if="resultado.fonteLegalLink"
                                                    target="_blank"
                                                    ng-href="{{resultado.fonteLegalLink}}">
                                                    {{resultado.fonteLegal}}
                                                </a>
                                                <span ng-if="!resultado.fonteLegalLink">{{resultado.fonteLegal}}</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </ef-collapse-content>
                    </ef-collapse>

                    <ef-collapse
                        class="col-xs-12"
                        ng-if="$ctrl.consulta.pisCofins.length || $ctrl.consulta.hasPisCofins === false"
                        cache-as="consulta-tributacao-cest-classificacao-pis-cofins">

                        <ef-collapse-header>
                            <h2>Classificação tributária PIS/COFINS</h2>
                        </ef-collapse-header>

                        <ef-collapse-content>
                            <div ng-if="!$ctrl.consulta.hasPisCofins" class="well well-xs no-padding">
                                <highlighted>
                                    <main>Os parâmetros de PIS/COFINS ainda não foram configurados para esta empresa.</main>
                                    <secondary>
                                        <a href="javascript:void(0)" ng-click="$ctrl.configurarPisCofins()">Clique aqui</a> para configurá-los.
                                    </secondary>
                                </highlighted>
                            </div>
                            <div ng-repeat="pisCofins in $ctrl.consulta.pisCofins" class="well well-xs no-padding">
                                <div class="no-margin">
                                    <div class="margin-10">
                                        <b>
                                            <i class="fa fa-info-circle"></i> {{pisCofins.descricao}}
                                        </b>
                                    </div>
                                    <div>
                                        <table class="table table-hover margin-bottom-0">
                                            <thead>
                                                <tr>
                                                    <th>Descrição</th>
                                                    <th width="1">SPED</th>
                                                    <th width="1">PIS</th>
                                                    <th width="1">COFINS</th>
                                                    <th width="1" class="text-center">Detalhes</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr ng-repeat="resultado in pisCofins.resultado.resultados">
                                                    <td>
                                                        {{resultado.descricaoProduto}}
                                                        <br>
                                                        <b>Operação:</b> {{resultado.situacao}}
                                                    </td>
                                                    <td class="no-break">
                                                        <b>Código:</b> {{resultado.codigo || '--'}}
                                                        <br>
                                                        <b>Tabela:</b> {{resultado.codigoTabela || '--'}}
                                                        <br>
                                                        <b>ExTipi:</b> {{resultado.excecaoIpi ? resultado.excecaoIpi : '--'}}
                                                    </td>
                                                    <td class="no-break">
                                                        <b>Alíquota:</b> {{resultado.pis == undefined ? 'Isento' : resultado.pis + '%' }}
                                                        <br>
                                                        <b>CST Entrada:</b> {{resultado.cst_pis_entrada}}
                                                        <br>
                                                        <b>CST Saída:</b> {{resultado.cst_pis_saida}}
                                                    </td>
                                                    <td class="no-break">
                                                        <b>Alíquota:</b> {{resultado.cofins == undefined ? 'Isento' : resultado.cofins + '%' }}
                                                        <br>
                                                        <b>CST Entrada:</b> {{resultado.cst_cofins_entrada}}
                                                        <br>
                                                        <b>CST Saída:</b> {{resultado.cst_cofins_saida}}
                                                    </td>
                                                    <td class="text-center text-primary">
                                                        <i 
                                                            class="fa fa-search-plus cursor-pointer"
                                                            ng-click="$ctrl.maisDetalhesPisCofins(pisCofins, resultado)">
                                                        </i>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>                                    
                        </ef-collapse-content>
                    </ef-collapse>

                    <ef-collapse
                        class="col-xs-12"
                        ng-if="$ctrl.consulta.icms || $ctrl.consulta.hasIcms === false"
                        cache-as="consulta-tributacao-cest-classificacao-icms">

                        <ef-collapse-header>
                            <h2>Classificação tributária ICMS</h2>
                        </ef-collapse-header>

                        <ef-collapse-content>
                            <div class="well well-xs no-padding">
                                <highlighted ng-if="!$ctrl.consulta.hasIcms">
                                    <main>Os parâmetros de ICMS ainda não foram configurados para esta empresa.</main>
                                    <secondary>
                                        <a href="javascript:void(0)" ng-click="$ctrl.configurarIcms()">Clique aqui</a> para configurá-los.
                                    </secondary>
                                </highlighted>

                                <table ng-if="$ctrl.consulta.hasIcms" class="table table-hover no-margin">
                                    <thead>
                                        <tr>
                                            <th>Enquadramento</th>
                                            <th>Descrição</th>
                                            <th>FECOEP</th>
                                            <th>Alíquota</th>
                                            <th ng-if="!$ctrl.empresa.icms.simplesNacional">CST</th>
                                            <th ng-if="$ctrl.empresa.icms.simplesNacional">CSOSN</th>
                                            <th class="text-center">Detalhes</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td class="no-break">{{$ctrl.consulta.icms.enquadramento}}</td>
                                            <td>{{$ctrl.consulta.icms.descricao || ''}}</td>
                                            <td>
                                                <span ng-if="$ctrl.consulta.icms.fecoep > 0">{{$ctrl.consulta.icms.fecoep}}%</span>
                                                <span ng-if="!$ctrl.consulta.icms.fecoep">--</span>
                                            </td>
                                            <td>{{$ctrl.consulta.icms.aliquota}}%</td>
                                            <td ng-if="$ctrl.consulta.icms.cst == '101'" class="no-break">PJ: 101/PF: 102</td>
                                            <td ng-if="$ctrl.consulta.icms.cst != '101'">{{$ctrl.consulta.icms.cst}}</td>
                                            <td style="vertical-align: middle; text-align: center" class="popover-big">
                                                <a
                                                    popover-placement="left"
                                                    popover-template="popover-detalhes-icms" 
                                                    popover-context="{resultado: $ctrl.consulta.icms, contrato: $ctrl.empresa}"
                                                    role="button" 
                                                    tabindex="0" 
                                                    class="cursor-pointer">
                                                    <i class="fa fa-search-plus"></i>
                                                </a>
                                            </td>
                                        </tr>
                                        <tr ng-if="$ctrl.consulta.icms.sugestoes.length">
                                            <th colspan="6">OUTROS POSSÍVEIS ENQUADRAMENTOS</th>
                                        </tr>
                                        <tr ng-repeat="sugestao in $ctrl.consulta.icms.sugestoes">
                                            <td class="no-break">{{sugestao.enquadramento}}</td>
                                            <td>{{sugestao.descricao || ''}}</td>
                                            <td>
                                                <span ng-if="sugestao.fecoep &gt; 0">{{sugestao.fecoep}}%</span>
                                                <span ng-if="!sugestao.fecoep">--</span>
                                            </td>
                                            <td>{{sugestao.aliquota}}%</td>
                                            <td ng-if="sugestao.cst == '101'" class="no-break">PJ: 101/PF: 102</td>
                                            <td ng-if="sugestao.cst != '101'">{{sugestao.cst}}</td>
                                            <td style="vertical-align: middle; text-align: center" class="popover-big">
                                                <a
                                                    popover-placement="left"
                                                    popover-template="popover-detalhes-icms" 
                                                    popover-context="{resultado: sugestao, contrato: $ctrl.empresa}"
                                                    role="button" 
                                                    tabindex="0"
                                                    class="cursor-pointer">
                                                    <i class="fa fa-search-plus"></i>
                                                </a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>                                 
                        </ef-collapse-content>
                    </ef-collapse>

                    <highlighted ng-if="$ctrl.error">
                        <main>
                            <div ng-bind-html="$ctrl.error" ></div>
                        </main>
                    </highlighted>

                    <div class="col-xs-12" ng-if="$ctrl.consulta.correlacionadas.length">
                        <h3 class="margin-bottom-10">
                            Foram identificadas as seguintes NCMs correlacionadas com a NCM buscada:
                        </h3>
                        <div ng-repeat="correlacao in $ctrl.consulta.correlacionadas">
                            <h4 class="margin-bottom-10">
                                {{correlacao.ncm | ncm}}
                            </h4>
                            <div class="well well-xs no-padding">
                                <table class="table table-hover no-margin">
                                    <thead>
                                        <tr>
                                            <th width="1">Classificação</th>
                                            <th>Descrição</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr ng-repeat="ncm in correlacao.dados">
                                            <td>{{ncm.classificacao | ncm}}</td>
                                            <td>{{ncm.descricao}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </loading>
            </div>
        </loading>
        <script type="text/ng-template" id="popover-detalhes-icms">
            <detalhes-tributacao-icms icms="$context.resultado" empresa="$context.contrato"></detalhes-tributacao-icms>
        </script>
        `
    })
